var map = {
	"./csr-1 (1).jpg": 1965,
	"./csr-1 (2).jpg": 1260,
	"./csr-1 (3).jpg": 4282,
	"./csr-1 (4).jpg": 5006,
	"./csr-1 (5).jpg": 7236,
	"./csr-2 (1).jpg": 652,
	"./csr-2 (2).jpg": 6838,
	"./csr-2 (3).jpg": 8061,
	"./csr-2 (4).jpg": 5407,
	"./csr-2 (5).jpg": 3603,
	"./csr-3 (1).jpg": 7063,
	"./csr-3 (2).jpg": 9876,
	"./csr-3 (3).jpg": 8901,
	"./csr-3 (4).jpg": 2691,
	"./csr-4 (1).jpg": 8899,
	"./csr-4 (2).jpg": 9167,
	"./csr-4 (3).jpg": 8476,
	"./csr-4 (4).jpg": 7114,
	"./csr-5 (1).jpg": 3780,
	"./csr-5 (2).jpg": 1354,
	"./csr-5 (3).jpg": 4173,
	"./csr-5 (4).jpg": 7263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2161;